<template>
    <div
        class="w-100 cursor-pointer transition-all px-1 py-3 selector border-radius-1 d-flex flex-row justify-space-between align-center primary--text position-relative"
    >
        <v-icon :disabled="disabled" class="icon--disabled primary--text mx-3 icon-medium">{{ 'mdi-volume-off' }}</v-icon>
        <div class="d-flex w-100 align-center">
            <slot></slot>
        </div>
        <v-icon :disabled="disabled" class="icon--disabled primary--text mx-3 icon-medium">{{ 'mdi-volume-high' }}</v-icon>
    </div>
</template>
<script>
export default {
    props: [ 'disabled' ],
    data: () => ({
        
    })
}
</script>

<style>
.primary--border {
    border: 1.5px solid #514773 !important;
}
.selector {
    background: white !important;
}
</style>
